import { PF_SECTIONS } from '../utils';

/** Section tabs — scroll-spy driven, like the AH dashboard's sub-nav. */
export function SubNav({ active, setActive }: { active: string; setActive: (id: string) => void }) {
  return (
    <div className="subnav">
      <div className="subnav-inner">
        {PF_SECTIONS.map((s) => (
          <button
            key={s.id}
            type="button"
            className={active === s.id ? 'active' : ''}
            onClick={() => {
              setActive(s.id);
              const el = document.getElementById(s.id);
              if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 110, behavior: 'smooth' });
            }}
          >
            {s.label}
          </button>
        ))}
      </div>
    </div>
  );
}
